import React from 'react'
import PropTypes from 'prop-types'

import './index.css'

const PhotoAsset = ({asset, onClick}) => {
  return (
    <div className="photo-asset" onClick={onClick}>
      <img src={asset.image.url} alt="Foto" />
    </div>
  )
}

PhotoAsset.propTypes = {
  asset: PropTypes.object.isRequired,
  onClick: PropTypes.func,
}

export default PhotoAsset
